import { useIntl } from 'react-intl'

import type { TDateArg } from '@/src/general/primitives/dates/date.types'

import type { TStreakItem } from './streak.type'
import { StreakBase, type TStreakBaseProps } from './StreakBase'
import { mapStreak } from './streakMapping'

type TStreakProps = {
  days: TStreakItem[]
  hasAnimatedToday: boolean
  today: TDateArg
} & Pick<TStreakBaseProps, 'title' | 'footer'>

export const Streak = ({ days, today, hasAnimatedToday, title, footer }: TStreakProps) => {
  const { locale } = useIntl()
  const streak = mapStreak(days, { today, hasAnimatedToday, locale })

  return <StreakBase {...streak} title={title} footer={footer} />
}
